import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, DollarSign } from 'lucide-react';
export function WhatWeDo() {
  return <section className="py-20 px-6 bg-white" data-id="element-58">
      <div className="max-w-7xl mx-auto" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-60">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-61">
            What We Do
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-emerald-50 rounded-2xl p-8 lg:p-10" data-id="element-63">
            <div className="flex items-center gap-3 mb-6" data-id="element-64">
              <div className="bg-emerald-600 p-3 rounded-lg" data-id="element-65">
                <TrendingUp className="w-6 h-6 text-white" data-id="element-66" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-67">
                For Advertisers
              </h3>
            </div>
            <p className="text-slate-700 leading-relaxed text-lg" data-id="element-68">
              We deliver qualified phone calls from consumers actively seeking
              your services right now. Every call is carefully filtered and
              verified to meet your exact criteria before it reaches your
              agents, so they can close them with no issues.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-slate-800 rounded-2xl p-8 lg:p-10" data-id="element-69">
            <div className="flex items-center gap-3 mb-6" data-id="element-70">
              <div className="bg-emerald-600 p-3 rounded-lg" data-id="element-71">
                <DollarSign className="w-6 h-6 text-white" data-id="element-72" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-73">For Publishers</h3>
            </div>
            <p className="text-slate-300 leading-relaxed text-lg" data-id="element-74">
              Turn your traffic into serious revenue. We buy quality calls
              across our key verticals and actively fight for better payment
              terms and higher rates on your behalf. You focus on driving
              traffic, we handle the rest. Reliable, on-time payments you can
              count on, every single time.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}